var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8395_18487",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8395_18487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 9C11.8125 10.5533 10.5533 11.8125 9 11.8125C7.44669 11.8125 6.1875 10.5533 6.1875 9C6.1875 7.44669 7.44669 6.1875 9 6.1875C10.5533 6.1875 11.8125 7.44669 11.8125 9Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96875 1.96875L16.0312 16.0312",
    stroke: "#4A4A4A",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.166 9C17.166 9 13.6609 14.625 9.00098 14.625C4.34105 14.625 0.835938 9 0.835938 9C0.835938 9 4.34105 3.375 9.00098 3.375C13.6609 3.375 17.166 9 17.166 9Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideeye);
export default __webpack_public_path__ + "static/media/hideeye.ab544b6eec2feab843a14144c334c90d.svg";
export { ForwardRef as ReactComponent };